<template>
    <v-dialog
        v-model="dialog" 
        persistent 
        scrollable
        max-width="500px"
        transition="dialog-transition">
        <template v-slot:activator="{ on }">
            <v-btn color="#0B3F67" dark v-on="on">Agregar<v-icon right>mdi-plus-box-outline</v-icon></v-btn>
        </template>
         <v-card :loading="laoding">
             <v-card-title class="pa-0">
               <ModalTitle titulo="Agregar Etiqueta" @cancelar="cancelar"/>
            </v-card-title>  
            <v-divider />
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Nombre"
                            v-model="etiqueta.nombre"
                            :error-messages="nameErrors"
                            @input="$v.etiqueta.nombre.$touch()"
                            @blur="$v.etiqueta.nombre.$touch()"
                            required>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="loading" color="error" @click="cancelar" >Cancelar</v-btn>
                <v-btn text :loading="loading" color="#0B3F67" @click="agregarEtiqueta">Agregar</v-btn>
            </v-card-actions>
         </v-card>      
    </v-dialog>    
</template>

<script>
import axios from "@/axios.js";
import {required, email} from "vuelidate/lib/validators";
import ModalTitle from '@/components/utils/ModalTitleComponent'
export default {
    computed: {
        nameErrors () {
            const errors = []
            if (!this.$v.etiqueta.nombre.$dirty) return errors            
            !this.$v.etiqueta.nombre.required && errors.push('El nombre es requerido.')
            return errors
        },
    },
   created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },   
    components: {
      ModalTitle
    },   
    data: () => ({
        dialog: false,
        loading: false,
        etiqueta: {
            nombre: ''  
        },        
    }),
    validations: {
        etiqueta: {  
            nombre: {
                required
            },
        }
    },
    methods:{
        cancelar() {
            this.etiqueta = {};
            this.dialog = !this.dialog;            
            this.$v.etiqueta.$reset();
            this.loading = false;
        },
        agregarEtiqueta() {
            this.$v.$touch();
            if(!this.$v.$invalid) {                
                axios.post("/etiquetas/agregarEtiqueta", this.etiqueta).then(response => {
                  this.$emit('recargaTabla');                                                            
                  this.$store.dispatch('noti',{mensaje: 'Etiqueta agregada', color:'success'});
                  this.cancelar();
                  }).catch(error => {
                    if (error.request && error.request.status === 401) {
                      this.$store.commit('showSessionDialog', true);
                    } else {
                      console.log("Error al agregar etiqueta " + error);
                      this.cancelar();
                      this.$store.dispatch('noti', {mensaje: 'Ocurrió un error no se agregó la etiqueta', color:'error'});
                      this.dialog = !this.dialog;
                    }
                })
            }
        }
    },
}
</script>